import React from "react";
export const pensionInfo = {
  PENSION_NAME: "무릉가족펜션",
};

export const carouselInfo = [
  {
    title: (
      <h3>
        자연과 함께하는 <span>펜션&채식농장</span>
      </h3>
    ),
    subContent: "맑은 공기와 ,탁트인 전망과 함께하세요.",
    mainContent: (
      <p>
        아름다운 추억과 즐거운 행복을 만들어가시길 바랍니다. <br />
        그림같은 자연경관과 함께, 가족,친구,연인과 함께 잊지 못할 <br />
        추억을 만들어가세요
      </p>
    ),
    img: "Main_main.jpeg",
  },
  {
    title: (
      <h3>
        마음을 힐링하는 <span>펜션 & 채식농장</span>
      </h3>
    ),
    subContent: "지친 일상을 힐링하세요.",
    mainContent: (
      <p>
        아름다운 추억과 즐거운 행복을 만들어가시길 바랍니다. <br />
        그림같은 자연경관과 함께, 가족,친구,연인과 함께 잊지 못할 <br />
        추억을 만들어가세요
      </p>
    ),
    img: "Main_main2.jpeg",
  },
  {
    title: (
      <h3>
        맘 편히 쉴수있는 <span>펜션 & 채식농장</span>
      </h3>
    ),
    subContent: "넓은 잔디밭과 함께, 휴식을 즐기세요.",
    mainContent: (
      <p>
        아름다운 추억과 즐거운 행복을 만들어가시길 바랍니다. <br />
        그림같은 자연경관과 함께, 가족,친구,연인과 함께 잊지 못할 <br />
        추억을 만들어가세요
      </p>
    ),
    img: "Main_main3.jpeg",
  },
];



// WEBPACK FOOTER //
// ./src/constant/data.js